/**
 * Historia médica (consultation record) — DR Reglamento Técnico del
 * Expediente Clínico (MISPAS 2023). Section keys are the fixed legal
 * skeleton (§6.3); order in RECORD_SECTION_KEYS is the render order.
 */
export const RECORD_SECTION_KEYS = [
    'ficha_identificacion',
    'motivo_consulta',
    'antecedentes',
    'enfermedad_actual',
    'examen_fisico',
    'evolucion',
    'resultados_estudios',
    'diagnosticos',
    'plan_tratamiento',
    'enmiendas',
];
//# sourceMappingURL=consultation-record.js.map